import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Badge } from 'react-bootstrap';
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaUserTie } from 'react-icons/fa';
import api from '../services/api';
import { getMediaUrl } from '../services/api';
import './WardCouncillors.css';

const WardCouncillors = () => {
  const [councillors, setCouncillors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadCouncillors();
  }, []);

  const loadCouncillors = async () => {
    try {
      const response = await api.get('/ward-councillors/');
      const data = response.data.results || response.data;
      setCouncillors(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Error loading ward councillors:', error);
      setCouncillors([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Container className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </Container>
    );
  }

  return (
    <Container className="py-5">
      <h1 className="page-title mb-2">Ward Councillors</h1>
      <p className="text-muted mb-4 text-center">
        Your elected representatives across all municipal wards
      </p>

      <Row className="justify-content-center">
        {councillors.map((councillor) => (
          <Col key={councillor.id} lg={4} md={6} className="mb-4">
            <Card className="councillor-card h-100 shadow border-0">
              <div className="councillor-header">
                {councillor.photo ? (
                  <img
                    src={getMediaUrl(councillor.photo)}
                    alt={councillor.name}
                    className="councillor-photo"
                  />
                ) : (
                  <div className="councillor-photo-placeholder">
                    <FaUserTie size={60} />
                  </div>
                )}
                <Badge bg="primary" className="ward-badge">
                  {councillor.ward_name}
                </Badge>
              </div>
              <Card.Body>
                <Card.Title className="councillor-name text-center mb-2">
                  {councillor.name}
                </Card.Title>
                <p className="councillor-designation text-center mb-3">
                  <strong>{councillor.designation}</strong>
                </p>

                {councillor.constituency && (
                  <div className="councillor-info mb-2">
                    <FaMapMarkerAlt className="info-icon" />
                    <span><strong>Constituency:</strong> {councillor.constituency}</span>
                  </div>
                )}                
                {/* {councillor.bio && (
                  <div className="councillor-bio mt-3">
                    <p className="bio-text">{councillor.bio}</p>
                  </div>
                )} */}
                {councillor.bio && (
                  <div className="councillor-bio mt-3">
                    <div 
                      className="bio-text" 
                      dangerouslySetInnerHTML={{ __html: councillor.bio }}
                    />
                  </div>
                )}


                <hr className="my-3" />

                <div className="contact-section">
                  {councillor.phone && (
                    <div className="councillor-info mb-2">
                      <FaPhone className="info-icon text-success" />
                      <a href={`tel:${councillor.phone}`} className="contact-link">
                        {councillor.phone}
                      </a>
                    </div>
                  )}
                  {councillor.email && (
                    <div className="councillor-info">
                      <FaEnvelope className="info-icon text-primary" />
                      <a href={`mailto:${councillor.email}`} className="contact-link">
                        {councillor.email}
                      </a>
                    </div>
                  )}
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {councillors.length === 0 && (
        <div className="text-center py-5">
          <p className="text-muted">No ward councillor information available at this time.</p>
        </div>
      )}
    </Container>
  );
};

export default WardCouncillors;
